<template>
    <header class="border-b border-gray lg:border-none flex flex-col gap-1 px-6 py-4 md:p-10 bg-white font-sans">
        <div class="flex items-center justify-between text-[13px]">
            <div class="flex items-center">
                <a
                    :href="logoLink"
                    class="cursor-pointer"
                >
                    <img
                        src="../assets/images/myjoys-logo.svg"
                        width="45"
                        height="22"
                        alt="MyJoys Logo"
                    >
                </a>

                <p>
                    <span class="inline-flex align-super">
                        &nbsp;/&nbsp;
                    </span>
                    <a
                        :href="departmentLink"
                        class="cursor-pointer inline-flex align-super"
                    >
                        {{ departmentTranslation }}
                    </a>
                </p>
            </div>

            <p class="self-baseline font-normal">
                #{{ productSku }}
            </p>
        </div>

        <h1 class="min-h-[2rem] text-2xl font-bold">
            {{ productName }}
        </h1>

        <h2 class="h-7 text-xl font-bold">
            {{ productPrice }}
        </h2>
    </header>
</template>

<script>
    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            state() {
                return this.viewController?.state;
            },

            productName() {
                return this.customizerStore.productName;
            },

            productPrice() {
                return this.customizerStore.productPrice;
            },

            productDepartment() {
                return this.customizerStore.productDepartment;
            },

            isFemale() {
                return this.productDepartment === 'F';
            },

            departmentTranslation() {
                let text = '';

                if (this.productDepartment) {
                    text = this.isFemale ? this.$t('WOMENS') : this.$t('MENS');
                }

                return text;
            },

            locale() {
                return this.customizerStore.options?.locale;
            },

            baseUrl() {
                return this.customizerStore.buildBaseUrl();
            },

            departmentLink() {
                const department = this.isFemale ? 'women/' : 'men/';

                return `${this.baseUrl}/design-your-own/${department}`;
            },

            logoLink() {
                return `${this.baseUrl}/design-your-own/`;
            },

            productSku() {
                return this.customizerStore.productSku;
            },
        },
    };
</script>
